import { getQueryStringParams } from "./getQueryStringParams";

export enum CustomerOrigin {
  ConsumerWebApp = "ConsumerWebApp",
  AdvisorWebApp = "AdvisorWebApp",
  FormsApp = "FormsApp",
  MarketingApp = "MarketingApp",
}

const STORAGE_KEY_ORIGIN = "AtticusCustomerOrigin";

// will get the origin from query string and save to sessionStorage
export const setCustomerOrigin = (win?: Window): void => {
  const theWindow = win || window;
  const params = getQueryStringParams();
  const { origin } = params;
  if (origin) {
    theWindow && theWindow.sessionStorage.setItem(STORAGE_KEY_ORIGIN, origin);
  }
};

// will return origin from sessionStorage
export const getCustomerOrigin = (win?: Window): string | undefined => {
  const theWindow = win || window;
  return (
    (theWindow && theWindow.sessionStorage.getItem(STORAGE_KEY_ORIGIN)) ||
    undefined
  );
};
